<template>
  <div v-if="showHeaderNav && isCheckLogin" class="public-header-container">
    <div class="public-header" :class="{ 'bg-opacity': headerOpacity }">
      <div class="public-header-center">
        <div class="public-header-icon header-index">
          <img :src="logoConfig.url" :alt="logoConfig.title" />
        </div>
        <div>
          <router-link
            class="public-header-title fs20"
            :class="{ 'default-cursor': activeBar === 'home' }"
            to="/"
            >{{ logoConfig.title }}</router-link
          >
        </div>
        <ul class="public-header-nav">
          <li :class="{ active: activeBar === 'home' }" @click="changBar(0)">
            <span class="header-item">首页</span>
          </li>
          <li @click="toAppStore">
            <span class="header-item">应用商店</span>
          </li>
          <li>
            <el-popover
              placement="bottom"
              width="680"
              :visible-arrow="false"
              popper-class="public-header-popover"
              trigger="hover"
            >
              <span slot="reference" class="header-item">
                <span>开发文档</span>
                <i class="el-icon-caret-bottom"></i>
              </span>
              <div class="header-popover-content">
                <div class="header-popover-items">
                  <h3 class="item-title-1">
                    <img src="../../assets/images/icon1.png" />基础文档
                  </h3>
                  <ul>
                    <li @click="goTo('baseDocument', { id: 'ptjs' })">
                      平台概述
                    </li>
                    <li @click="goTo('baseDocument', { id: 'rgs' })">
                      开发者注册流程
                    </li>
                    <li @click="goTo('baseDocument', { id: 'cjlc' })">
                      应用创建流程
                    </li>
                    <li @click="goTo('baseDocument', { id: 'wdzx' })">
                      文档中心
                    </li>
                    <li @click="goTo('baseDocument', { id: 'cjwt' })">
                      常见问题
                    </li>
                  </ul>
                </div>
                <div class="header-popover-items">
                  <h3 class="item-title-2">
                    <img src="../../assets/images/icon2.png" />服务能力
                  </h3>
                  <ul>
                    <li @click="goTo('ssoDocument')">统一用户认证</li>
                    <li @click="goTo('apiDocument')">API接入</li>
                    <li
                      @click="goTo('dataExchangeDocument')"
                      v-if="isShowDataExchange"
                    >
                      数据互操作
                    </li>
                    <!-- <li @click="goTo('miniProgramDocument')">小程序</li>
                    -->
                  </ul>
                </div>
                <div class="header-popover-items">
                  <h3 class="item-title-3">
                    <img src="../../assets/images/icon3.png" />平台规范
                  </h3>
                  <ul>
                    <li @click="goTo('standardDocument', { id: 'summary' })">
                      综述
                    </li>
                    <li
                      @click="
                        goTo('standardDocument', { id: 'designPrinciples' })
                      "
                    >
                      设计原则
                    </li>
                    <li @click="goTo('standardDocument', { id: 'color' })">
                      设计规范
                    </li>
                  </ul>
                </div>
                <div class="header-popover-items">
                  <h3 class="item-title-4">
                    <img src="../../assets/images/icon4.png" />附录
                  </h3>
                  <ul>
                    <li @click="goTo('appendixDocument', { id: 'noun' })">
                      名词解释
                    </li>
                    <li @click="goTo('appendixDocument', { id: 'resources' })">
                      资源下载
                    </li>
                  </ul>
                </div>
              </div>
            </el-popover>
          </li>
          <li
            v-if="hasLogin"
            :class="{ active: activeBar === 'personal' }"
            @click="changBar(2)"
          >
            <span class="header-item">个人中心</span>
          </li>
          <!-- <li @click="changBar(3)" :class="{'active': activeBar === 'document'}">
            <span class="header-item">文档中心</span>
          </li> -->
        </ul>
        <el-dropdown class="header-user" trigger="click" v-if="hasLogin">
          <span class="el-dropdown-link">
            {{ user.name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="toPersonalInfo()"
              >个人设置</el-dropdown-item
            >
            <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
            <!-- <el-dropdown-item disabled>不可选</el-dropdown-item> -->
          </el-dropdown-menu>
        </el-dropdown>
        <div class="public-header-tips" v-if="hasLogin">
          <span v-if="user.status == 0">未认证</span>
          <span v-if="user.status == 1">认证中</span>
          <span v-if="user.status == 2">企业开发者</span>
          <span v-if="user.status == 3">认证失败</span>
        </div>
        <div class="public-header-login" v-if="!hasLogin">
          <span @click="loginDialog = true">登录</span>
          <span @click="goRegister()">注册</span>
        </div>
      </div>
    </div>
    <!-- 登录 -->
    <div class="public-login-main">
      <el-dialog
        :visible.sync="loginDialog"
        :close-on-click-modal="false"
        :before-close="beforeClose"
      >
        <div class="public-login-left-main"></div>
        <div class="public-login-right-main">
          <div class="public-login-right-title">开放平台账号登录</div>
          <el-form
            :model="ruleForm"
            status-icon
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm"
          >
            <el-form-item>
              <el-input
                v-model="ruleForm.name"
                placeholder="用户名"
                v-on:keyup.enter.native="submitForm"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-input
                type="password"
                v-model="ruleForm.pass"
                auto-complete="off"
                placeholder="密码"
                v-on:keyup.enter.native="submitForm"
              ></el-input>
            </el-form-item>
            <el-form-item class="public-login-code" v-if="loginTimes > 3">
              <el-input
                v-model="ruleForm.code"
                placeholder="验证码"
                v-on:keyup.enter.native="submitForm"
              ></el-input>
              <img
                @click="clickValidare"
                ref="ValidareCodeImage"
                v-bind:src="ValidareCodeUrl"
              />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm()">登录</el-button>
            </el-form-item>
          </el-form>
          <div class="login-set-main">
            <!--<el-checkbox v-model="rememberUsers">记住用户名</el-checkbox>-->
            <el-button type="text" @click="findPassWord()">忘记密码</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- <div class="public-login-main">
      <el-dialog :visible.sync="loginDialog" :close-on-click-modal="false" :before-close="beforeClose">
        <div class="login">
          <a class="login-close" href="javascript:;" @click="loginDialog = false"></a>
          <h1 class="login-logo">
            <img src="../../../static/img/login-logo.png">
          </h1>
          <h3 class="login-h3">开放平台</h3>
          <div class="login-box">
            <div class="login-c">
              <p class="login-title">登&nbsp;录</p>
              <el-form :model="ruleForm" status-icon ref="ruleForm" class="demo-ruleForm">
                <el-form-item>
                  <el-input
                    prefix-icon="el-icon-user"
                    v-model="ruleForm.name"
                    placeholder="用户名"
                    v-on:keyup.enter.native="submitForm"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    type="password"
                    prefix-icon="el-icon-password"
                    v-model="ruleForm.pass"
                    auto-complete="off"
                    placeholder="密码"
                    v-on:keyup.enter.native="submitForm"></el-input>
                </el-form-item>
                <el-form-item class="public-login-code" v-if="loginTimes>3">
                  <el-input class="login-code" v-model="ruleForm.code" placeholder="验证码" v-on:keyup.enter.native="submitForm"></el-input>
                  <img @click="clickValidare" class="login-code-img" ref="ValidareCodeImage"  v-bind:src="ValidareCodeUrl" />
                </el-form-item>
                <div v-if="loginTimes>3">
                  <span class="login-code-change" @click="clickValidare">看不清换一张</span>
                </div>
                <el-form-item>
                  <el-button class="public-login-btn" type="primary" @click="submitForm()">登录</el-button>
                </el-form-item>
              </el-form>
              <div class="login-set-main">
                <el-button type="text" class="login-register-btn" @click="goRegisterFromPanel()">注册</el-button>
                <el-button type="text" style="float: right;" @click="findPassWord()">找回密码</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div> -->
    <el-dialog
      title="开放平台开发者协议和用户隐私协议"
      :visible.sync="protocolDialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="_closeProtocalBox"
    >
      <security-protocol
        :isUpdate="true"
        @aggree-protocol="_aggreeProtocalBox"
        @refuse-protocol="_closeProtocalBox"
      >
      </security-protocol>
    </el-dialog>
  </div>
</template>

<script>
import { rootUrl, ReturnCode } from "@/common/js/config";
import {
  login,
  compareValidareCode,
  logout,
  checkLogin,
  getStoreUrl,
  saveUserProtocol,
  getSSOConfig,
} from "@/api/login-api";
import { getRaskey } from "@/api/developer/developer-api";
import util from "@/common/js/util";
import store from "@/store/index";
import security from "@/common/js/security";
import base64 from "@/common/js/sso/base64";
import mathUUID from "@/common/js/sso/Math.uuid";
import ssoUrl from "@/common/js/sso/url";
import sso from "@/common/js/sso/sso";
import SecurityProtocol from "@/pages/register/security-protocol";
// import $ from 'jquery'
let $ = window.jQuery;
import * as CommonAPI from "@/api/common-api.js";
import service from "@/pages/exchangeDataManage/services";
export default {
  data() {
    return {
      logoConfig: {
        url: require("./../../assets/images/header_icon.png"),
        title: "开放平台",
      },
      headerOpacity: false, // 背景是否透明
      activeBar: "home", // 当前展示的页面 personal:个人中心
      isAuth: true,
      hasLogin: false,
      loginDialog: false, // 登录框
      rememberUsers: false, // 记住用户名
      isCheckLogin: false, // 不清楚以前这个地方奇怪的登陆验证逻辑，增加一个属性，在登陆认证之后再显示导航条。
      loginTimes: 1, //登录次数
      user: {}, //用户信息
      appStroeUrl: "",
      ValidareCodeUrl: rootUrl.getValidareCode, //获取验证码地址
      ruleForm: {
        name: "",
        pass: "",
        code: "",
      },
      showHeaderNav: true,
      protocolDialogVisible: false,
      ssoInfo: {
        serverUrl: "",
        redirectUrl: "",
        loginUrl: "",
      },
      isShowDataExchange: false,
    };
  },
  created() {
    this._getLogoConfigVoByPlatform();
    this._getExchangeMenuEnable();
    this._getSSOConfig();
    if (
      this.$store.state.headerActive === "securityProtocolPage" ||
      this.$store.state.headerActive === "privateProtocolPage"
    ) {
      this.showHeaderNav = false;
    } else {
      this.checkLogin();
      if (this.$store.state.headerActive === "home") {
        this.changBar(0);
      } else if (this.$store.state.headerActive === "personalHome") {
        this.changBar(2);
      } else if (this.$store.state.headerActive === "document") {
        this.changBar(3);
      }
    }
  },
  components: {
    SecurityProtocol,
  },
  mounted() {
    this.appStroeUrl =
      util.localstorage.get("appStroeUrl") == null
        ? this.getStoreUrl()
        : util.localstorage.get("appStroeUrl");
    this.hasLogin =
      util.localstorage.get("hasLogin") == null
        ? this.hasLogin
        : util.localstorage.get("hasLogin");
    // if(typeof (util.localstorage.get("user")) != "object"){
    //   this.user = util.localstorage.get("user")==null?this.user: JSON.parse(util.localstorage.get("user"));
    // }else {
    //   this.user = util.localstorage.get("user")==null?this.user: util.localstorage.get("user");
    // }
    this.activeBar =
      util.localstorage.get("activeBar") == null
        ? this.activeBar
        : util.localstorage.get("activeBar");
    // if(this.user.status==2){
    //   this.isAuth = true;
    // }else {
    //   this.isAuth = false;
    // }
  },
  computed: {
    openLoginDialog() {
      return this.$store.state.showLoginDialog;
    },
    refreshPersonInfo() {
      return this.$store.state.refreshHeader;
    },
    userStatusChange() {
      return this.$store.state.userStatusChange;
    },
    headerActive() {
      return this.$store.state.headerActive;
    },
  },
  watch: {
    openLoginDialog: function () {
      this.loginDialog = this.$store.state.showLoginDialog;
    },
    refreshPersonInfo: function () {
      this.checkLogin();
    },
    headerActive: function () {
      if (this.$store.state.headerActive === "home") {
        this.changeActiveBar(0);
      } else if (this.$store.state.headerActive === "personalHome") {
        this.changeActiveBar(2);
      }
    },
    userStatusChange: function () {
      if (typeof util.localstorage.get("user") != "object") {
        this.user =
          util.localstorage.get("user") == null
            ? this.user
            : JSON.parse(util.localstorage.get("user"));
      } else {
        this.user =
          util.localstorage.get("user") == null
            ? this.user
            : util.localstorage.get("user");
      }
      if (this.user.status == 2) {
        this.isAuth = true;
      } else {
        this.isAuth = false;
      }
      store.commit("judgeUserStatusChange", {
        flag: false,
      });
    },
    loginDialog: function () {
      this.ruleForm.name = "";
      this.ruleForm.pass = "";
      this.ruleForm.code = "";
    },
  },
  methods: {
    //根据平台类型获取平台logo
    _getLogoConfigVoByPlatform() {
      service
        .getLogoConfigVoByPlatform()
        .then((res) => {
          if (res !== null) {
            this.logoConfig = res;
          }
        })
        .catch((err) => {});
    },
    _getExchangeMenuEnable() {
      let that = this;
      CommonAPI.getExchangeMenuEnable()
        .then((res) => {
          if (res.code == ReturnCode.success) {
            that.isShowDataExchange = res.data;
          }
        })
        .catch((err) => {});
    },
    goTo(name, query) {
      // this.$router.push({ name: name, query: query})
      let routeUrl = this.$router.resolve({ name: name, query: query });
      window.open(routeUrl.href, "_blank");
    },
    _closeProtocalBox() {
      this.protocolDialogVisible = false;
    },
    _aggreeProtocalBox() {
      this.protocolDialogVisible = false;
      let params = {
        userName: this.ruleForm.name,
      };
      saveUserProtocol(params)
        .then((res) => {
          if (res.code == 1) {
            this.loginAjax();
          }
        })
        .catch((err) => {});
    },
    changBar(index) {
      if (index === 0) {
        this.activeBar = "home";
        this.$router.replace({ name: "home" });
        //放入缓存，避免刷新页面后，选中效果重置
        store.commit("headerActive", "home");
        util.localstorage.set("activeBar", this.activeBar);
      } else if (index === 2) {
        this.activeBar = "personal";
        this.$router.replace({ name: "personalHome" });
        //放入缓存，避免刷新页面后，选中效果重置
        store.commit("headerActive", "personalHome");
        util.localstorage.set("activeBar", this.activeBar);
      } else if (index === 3) {
        this.activeBar = "document";
        // window.open(this.documentCenter, '_blank')
        // this.$router.push({path:'/documentCenter'})
        this.$router.replace({ name: "documentCenter" });
        //放入缓存，避免刷新页面后，选中效果重置
        store.commit("headerActive", "documentCenter");
        util.localstorage.set("activeBar", this.activeBar);
      } else if (index === 4) {
        // 开发文档
        this.$router.replace({ name: "baseDocument" });
      } else {
        // TODO:跳转到商店外链接
      }
    },
    //修改头部选中效果
    changeActiveBar(index) {
      if (index === 0) {
        this.activeBar = "home";
      } else if (index === 2) {
        this.activeBar = "personal";
      } else if (index === 3) {
        this.activeBar = "document";
      }
    },
    goRegisterFromPanel() {
      this.loginDialog = false;
      this.$store.commit("changeLoginDialog", {
        isShow: false,
      });
      this.goRegister();
    },
    findPassWord() {
      this.loginDialog = false;
      this.$store.commit("changeLoginDialog", {
        isShow: false,
      });
      this.$router.push({
        path: "/FindPassWord",
        query: {
          round: Math.random(),
        },
      });
    },
    // 注册
    goRegister() {
      this.$router.replace({ name: "register" });
    },
    // 前往个人信息页面
    toPersonalInfo() {
      this.$router.replace({ name: "personalInfo" });
    },
    //前往应用商店
    toAppStore() {
      window.open(this.appStroeUrl, "_blank");
    },
    //文档中心
    toDocumentCenter() {
      this.activeBar = "document";
      // window.open(this.documentCenter, '_blank')
      // this.$router.push({path:'/documentCenter'})
      this.$router.replace({ name: "documentCenter" });
      //放入缓存，避免刷新页面后，选中效果重置
      store.commit("headerActive", "documentCenter");
      util.localstorage.set("activeBar", this.activeBar);
    },
    // 前往认证页面
    toRegister() {
      this.$router.push({
        path: "/register",
        query: {
          step: 2,
        },
      });
    },
    _clearSubmitInfo() {
      let that = this;
      that.hasLogin = false;
      that.isAuth = false;
      that.$store.commit("changeLoginDialog", {
        isShow: false,
      });
      //登出清除缓存
      util.localstorage.clear();
      if (
        that.$store.state.headerActive !== "securityProtocolPage" &&
        that.$store.state.headerActive !== "privateProtocolPage"
      ) {
        that.$router.push({
          path: "/home",
        });
      }
    },
    // 不能直接用localstorage.clear()，因为会清除其它path下的localstorage
    // 比如会把云平台下面的localstorage清除掉。
    clearUserInfo() {
      util.localstorage.removeItem("user");
      util.localstorage.removeItem("hasLogin");
    },
    //检测登录
    checkLogin() {
      let that = this;
      this.isCheckLogin = false;
      checkLogin()
        .then((res) => {
          this.isCheckLogin = true;
          if (res.code == "-1") {
            // 只要未登录，就清除用户信息，而不存储。
            // 不确认是否有其它问题，为了解决未登录用户，
            // 在不需要checkLogin页面刷新而重新调回首页的问题。
            this.user = {};
            this.isAuth = false;
            this.hasLogin = false;
            this.clearUserInfo();
            $.ajax({
              url: SSO.SSOServerUrl + "/login",
              type: "GET",
              dataType: "jsonp",
              jsonp: "callback",
              crossDomain: true,
              cache: false,
              success: (html) => {
                html = $.trim(html).replace(/\t/g, "");
                let resultObj = eval("(" + html + ")");
                if (resultObj.code === 1001) {
                  window.location.href = that.ssoInfo.redirectUrl;
                } else {
                  // fixme: 先注释掉，不然会导致刷新页面的时候未登录的会跳转到首页。
                  // that._clearSubmitInfo();
                }
              },
              error: function (resultObj) {
                that._clearSubmitInfo();
              },
            });
          } else {
            // let path = that.$route ? that.$route.name : '';
            that.hasLogin = true;
            that.loginDialog = false;
            that.hasLogin = true;
            that.loginTimes = 1;
            that.user = res.data;
            util.localstorage.set("loginDialog", that.loginDialog);
            util.localstorage.set("hasLogin", that.hasLogin);
            this.$store.commit("SET_USER_INFO", res.data);
            util.localstorage.set("user", that.user);
            store.commit("changeRefreshHeader", {
              headerRefresh: false,
            });
            if (that.user.status == 2) {
              that.isAuth = true;
            } else {
              that.isAuth = false;
            }
            util.localstorage.set("activeBar", that.activeBar);
            // 将之前跳转到个人中心更改为跳转到登录前的所在页面
            // warning: 暂时注释掉，目前只有首页才有登陆。如果要实现上面注释的功能，需要判断是否存在path。刷新的时候path为null
            // that.$router.replace({name: path})
          }
        })
        .catch((error) => {
          this.isCheckLogin = true;
        });
    },
    //获取应用商店地址
    getStoreUrl() {
      getStoreUrl()
        .then((res) => {
          this.appStroeUrl = res.data;
          util.localstorage.set("appStroeUrl", this.appStroeUrl);
        })
        .catch((error) => {});
    },
    //关闭弹框前对全局控制登录框是否显示的标识进行处理
    beforeClose() {
      this.$store.commit("changeLoginDialog", {
        isShow: false,
      });
      this.loginDialog = false;
    },
    // logout() {
    //   logout().then(res => {
    //     this.$router.push({
    //       path:'/login'
    //     })
    //   }).catch(error => {
    //     console.log(error)
    //   })
    // },
    //登录流程
    _getSSOConfig() {
      let that = this;
      getSSOConfig()
        .then((res) => {
          if (res.code == "1") {
            that.ssoInfo.serverUrl = res.data.ssoServerUrl;
            that.ssoInfo.redirectUrl = res.data.ssoRedirectUrl;
            that.ssoInfo.loginUrl = res.data.ssoLoginUrl;
            SSO.SSOServerUrl = that.ssoInfo.serverUrl;
            SSO.SSOCenterServerUrl = that.ssoInfo.serverUrl;
            SSO.loginRedirectUrl = that.ssoInfo.redirectUrl;
            SSO.isCenterSSO = true;
            SSO.needToken = false;
            SSO.syncType = 0;
          }
        })
        .catch((err) => {});
    },
    submitForm() {
      if (this.ruleForm.name == "") {
        this.$message({
          type: "error",
          message: "账号/密码不能为空 ",
        });
        return;
      } else if (this.ruleForm.pass == "") {
        this.$message({
          type: "error",
          message: "账号/密码不能为空",
        });
        return;
      }
      if (this.loginTimes <= 3) {
        this.loginAjax();
      } else {
        if (this.ruleForm.code == "") {
          this.$message({
            type: "error",
            message: "验证码不可为空",
          });
          return;
        }
        compareValidareCode(this.ruleForm.code)
          .then((res) => {
            if (res.code == 1) {
              //验证码正确，进行登录
              this.loginAjax();
            } else {
              //验证码错误，刷新验证码图片
              this.$refs.ValidareCodeImage.src =
                this.ValidareCodeUrl + "?timestamp=" + new Date().valueOf();
              this.$message({
                type: "error",
                message: "验证码错误",
              });
              return;
            }
          })
          .catch((error) => {});
      }
    },
    //更换验证码
    clickValidare() {
      this.$refs.ValidareCodeImage.src =
        this.ValidareCodeUrl + "?timestamp=" + new Date().valueOf();
    },
    //封装登录处理
    loginAjax() {
      let that = this;
      getRaskey()
        .then((res) => {
          // debugger
          var sexadecimalModulus = res.data.sexadecimalModulus; //获取摸
          var sexadecimalExponent = res.data.sexadecimalExponent; //获取公钥
          var modules = res.data.modulus; //获取用来解密的key
          var key = new RSAUtils.getKeyPair(
            sexadecimalExponent,
            "",
            sexadecimalModulus
          );
          var reversedPass = this.ruleForm.pass.split("").reverse().join(""); //电话号码倒序
          var encrypedPass = RSAUtils.encryptedString(key, reversedPass); //加密
          let user = {};
          user.loginname = this.ruleForm.name;
          user.password = encrypedPass;
          user.modules = modules;
          login(user)
            .then((res) => {
              let path = that.$route.name;
              if (res.code == 1) {
                /* SSO登录 */
                SSO._retry = true;
                let loginParam = {};
                loginParam.loginType = SSO.loginType.LOGINBYGENERIC;
                loginParam.genericValidateUserAttributes = encodeURIComponent(
                  `{"validateUserUrlKey":"sso.validateUserUrl","userName":"${user.loginname}","password":"${user.password}","modules":"${user.modules}"}`
                );
                loginParam.genericUserInfoAttributes = encodeURIComponent(
                  `{"getUserInfoUrlKey":"sso.getUserInfoUrl","userName":"${user.loginname}","password":"${user.password}","modules":"${user.modules}"}`
                );
                SSO.loginExt(loginParam, function (resultObj) {
                  // 登陆成功了，但是这里报错了，什么情况？？？
                  if (resultObj.code === 1001) {
                    window.location.href = that.ssoInfo.redirectUrl;
                  }
                });
              } else if (res.code == "-4001") {
                //安全协议更改时需重新签署安全协议
                that.protocolDialogVisible = true;
              } else {
                this.loginTimes++;
                this.$message({
                  type: "error",
                  message: res.message,
                });
                //登录失败，刷新验证码图片
                this.$refs.ValidareCodeImage.src =
                  this.ValidareCodeUrl + "?timestamp=" + new Date().valueOf();
              }
            })
            .catch((error) => {});
        })
        .catch((error) => {});
    },
    logout() {
      let that = this;
      SSO.logout(function (backInfo) {
        if (backInfo.code === 2001) {
          logout()
            .then((res) => {
              that.hasLogin = false;
              that.isAuth = false;
              that.$store.commit("changeIsLogOut", {
                isLogOut: true,
              });
              that.$store.commit("changeLoginDialog", {
                isShow: false,
              });
              store.commit("headerActive", "home");
              //登出清除缓存
              util.localstorage.clear();
              window.location.reload();
            })
            .catch((error) => {});
        }
      });
    },
  },
};
</script>

<style scoped>
.public-header .el-dropdown {
  margin-top: 0;
}
.item-title-1 {
  color: #f59191;
}
.item-title-2 {
  color: #798cf6;
}
.item-title-3 {
  color: #3ba2f9;
}
.item-title-4 {
  color: #3ebd91;
}
.login {
  width: 720px;
  height: 500px;
  background: url(../../../static/img/login_bg.png) no-repeat center;
  position: relative;
}
/* .public-login-main >>> .el-dialog {
  background: none;
}
.public-login-main >>> .el-dialog__header {
  display: none;
} */
.login-close {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 38px;
  height: 38px;
  background: url(../../../static/img/login_close.png) no-repeat center;
}
.login-logo {
  position: absolute;
  top: 144px;
  right: 135px;
  width: 90px;
  height: 90px;
}
.login-h3 {
  position: absolute;
  top: 250px;
  right: 0px;
  width: 360px;
  line-height: 28px;
  text-align: center;
  font-size: 22px;
  color: #fff;
  font-weight: bold;
}
.login-box {
  margin-top: 20px;
  width: 360px;
}
.login-c {
  margin: 0 auto;
  width: 280px;
  font-size: 14px;
  color: #666;
  padding-top: 20px;
}
.login-title {
  line-height: 100px;
  font-size: 22px;
  color: #333;
  text-align: center;
}
/* .public-login-main >>> .el-icon-user {
  background: url(../../../static/img/login_icon.png) no-repeat 4px 13px;
  background-size: 14px 101px;
}
.public-login-main >>> .el-icon-password {
  background: url(../../../static/img/login_icon.png) no-repeat 3px -28px;
  background-size: 14px 101px;
}
.public-login-main >>> .el-button--primary {
  background-color: #5d87d7;
  border-color: #5d87d7;
} */
/* .public-login-main >>> .el-dialog__body {
  padding: 0;
} */
.login-code {
  width: 185px;
}
.login-code-img {
  vertical-align: middle;
  margin-top: -2px;
}
.login-code-change {
  display: block;
  text-align: right;
  margin-top: -20px;
  margin-bottom: 15px;
  color: #306fdd;
  cursor: pointer;
}
.public-login-btn {
  margin-top: 20px;
  width: 100%;
}
/* .login-set-main {
  position: absolute;
  bottom: 25px;
  border-top: 1px solid #dddfe5;
  width: 284px;
  padding-top: 5px;
} */
.login-register-btn {
  color: #c1c4cb;
}
</style>
<style>
.public-header-popover {
  padding: 0;
  border: none;
  margin-top: 0px !important;
}
.header-popover-content {
  background: #fff;
  overflow: hidden;
  padding: 20px 0;
}
.header-popover-items {
  float: left;
  position: relative;
  padding-left: 35px;
  font-size: 14px;
  color: #909399;
  margin: 0px 18px;
}
.header-popover-items::after {
  content: "";
  position: absolute;
  top: 30px;
  right: -20px;
  width: 1px;
  height: 115px;
  background: url(../../assets/images/split-line.png);
}
.header-popover-items:last-child::after {
  display: none;
}
.header-popover-items img {
  position: absolute;
  left: 0;
  top: 0;
}
.header-popover-items h3 {
  font-size: 16px;
  margin-bottom: 25px;
}
.header-popover-items li {
  margin-bottom: 14px;
  cursor: pointer;
}
.header-popover-items li:hover {
  color: #3ba2f9;
}
.public-header .header-user.el-dropdown {
  margin-top: 15px;
}
.header-index {
  background: none;
}
.header-index img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/public-header/public-header.vue